import { Box, ActionIcon, useMantineColorScheme } from '@mantine/core';
import { createStyles } from '@mantine/core';
import { SunIcon, MoonIcon } from './ThemeProvider';

function AppContainer({ children, ...other }) {
  const { classes } = useStyles();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  return (
    <>
      <Box className={classes.container} {...other}>
        <ActionIcon
          radius="xl"
          variant={colorScheme !== 'dark' ? 'filled' : 'subtle'}
          color={colorScheme !== 'dark' ? 'dark' : 'green'}
          onClick={() => toggleColorScheme()}
          title="Toggle color scheme"
          className={classes.themeToggle}>
          {colorScheme === 'dark' ? (
            <SunIcon size={18} />
          ) : (
            <MoonIcon size={18} />
          )}
        </ActionIcon>
        {children}
      </Box>
    </>
  );
}

export default AppContainer;

const useStyles = createStyles(theme => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    // overflow: 'hidden',
  },
  themeToggle: {
    position: 'fixed',
    top: '1rem',
    right: '1rem',
    zIndex: 1000,
  },
}));
